(() => {
    // Function to inject modal CSS
    const injectModalCSS = () => {
      const style = document.createElement('style');
      style.innerHTML = `
        .modal {
          display: none; /* Hidden by default */
          position: fixed; /* Stay in place */
          z-index: 1000; /* Sit on top */
          left: 0;
          top: 0;
          width: 100%; /* Full width */
          height: 100%; /* Full height */
          overflow: auto; /* Enable scroll if needed */
          background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
          display: flex;
          align-items: center;
          justify-content: center;
        }
  
        .modal-content {
          background-color: #fefefe;
          border: 1px solid #888;
          width: 80%; /* Could be more or less, depending on screen size */
          max-width: 500px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.3);
          text-align: center;
          position: relative;
        }
  
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e5e5e5;
          padding: 11px 20px;
          background-color: #F0F0F0;
          margin-bottom: 20px;
        }
  
        .modal-header h2 {
          margin: 0;
          color: red;
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: "EarlSans-Regular", sans-serif;
          font-weight: 700;
        }
  
        .modal-header h2 svg {
          margin-right: 10px;
        }
  
        .close-button {
          font-size: 28px;
          cursor: pointer;
        }
  
        .modal-body {
          font-family: "EarlSans-Regular", sans-serif;
        }
  
        .modal-footer {
          display: flex;
          justify-content: center;
          padding: 20px 0px;
        }
  
        .ok-button {
          background-color: black;
          color: white;
          padding: 10px 20px;
          border: none;
          cursor: pointer;
          font-size: 16px;
          font-family: "EarlSans-Regular", sans-serif;
        }
  
        .ok-button:hover {
          background-color: #333;
        }
      `;
      document.head.appendChild(style);
    };
  
    // Function to show the modal
    const showModal = () => {
      injectModalCSS();
  
      const modalHTML = `
        <div class="modal" id="expireModal">
          <div class="modal-content">
            <div class="modal-header">
              <h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-triangle"><path d="M10.29 3.86l-9 16A1 1 0 002 21h20a1 1 0 00.87-1.5l-9-16a1 1 0 00-1.74 0zM12 9v4m0 4h.01"></path></svg>
                Party Expired
              </h2>
              <span class="close-button" id="closeModal">&times;</span>
            </div>
            <div class="modal-body">
              <p>The selected party is expired.</p>
            </div>
            <div class="modal-footer">
              <button class="ok-button" id="okButton">Shop Without a Party</button>
            </div>
          </div>
        </div>
      `;
  
      document.body.insertAdjacentHTML('beforeend', modalHTML);
  
      const modal = document.getElementById('expireModal');
      const closeButton = document.getElementById('closeModal');
      const okButton = document.getElementById('okButton');
  
      modal.style.display = 'flex'; // Show the modal with flex display
  
      const handleCloseModal = () => {
        modal.style.display = 'none';
        localStorage.removeItem('twpid');
        localStorage.removeItem('party');
        localStorage.removeItem('__attribution-party-id');
        removeTwpidFromURL();
      };
  
      closeButton.addEventListener('click', handleCloseModal);
      okButton.addEventListener('click', handleCloseModal);
  
      window.addEventListener('click', (event) => {
        if (event.target == modal) {
          handleCloseModal();
        }
      });
    };
  
    // Function to check party expiration and show modal
    const checkPartyExpiration = async () => {
      const partyId = localStorage.getItem('twpid');
      if (!partyId) return;
  
      const response = await fetch(`https://soa.tupperware.com/twgb/shopify/jk/get/partydetails/v1rs?Country=US&PartyNumber=${partyId}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });
  
      if (response.ok) {
        const result = await response.json();
        if (result.Party) {
          const expireDate = result.Party.ExpireDate ? new Date(result.Party.ExpireDate) : null;
          const currentDate = new Date();
  
          // Check if ExpireDate is not null and compare the dates
          if (expireDate && expireDate < currentDate) {
            showModal();
          }
        }
      }
    };
  
    // Function to remove twpid from the URL and reload the page
    const removeTwpidFromURL = () => {
      const url = new URL(window.location.href);
      const twcId = url.searchParams.get('twcId');
      url.searchParams.delete('twpid');
      let newUrl = url.origin + url.pathname;
      if (twcId) {
        newUrl += `?twcId=${twcId}`;
      }
      // Reload the page with the new URL
      window.location.replace(newUrl);
    };
  
    // Execute the function on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', checkPartyExpiration);
  })();
  